import Axios from 'axios';
import { getToken } from '../utils/auth-helpers';

/**
 * Servicio para operaciones relacionadas con menús
 */

/**
 * Valida las condiciones de un menú específico bajo demanda
 * @param {string} menuId - ID del menú a validar
 * @returns {Promise<Array>} Lista de condiciones aplicables
 */
export async function validarCondicionesMenu(menuId) {
  const token = getToken();
  const options = {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  };

  try {
    const res = await Axios.get(`/api/v1/navegacion/validar-condiciones/${menuId}`, options);
    const result = res.data?.result || {};
    return {
      tieneAccesoCompleto: result.tieneAccesoCompleto ?? true,
      hijosPermitidos: result.hijosPermitidos ?? [],
      condicionesHijos: result.condicionesHijos ?? []
    };
  } catch (error) {
    console.error(`Error al validar condiciones para menú ${menuId}:`, error);
    // Por defecto, acceso completo en caso de error
    return {
      tieneAccesoCompleto: true,
      hijosPermitidos: [],
      condicionesHijos: []
    };
  }
}

/**
 * Cache para condiciones de menús (evita peticiones repetidas)
 */
const condicionesCache = new Map();

/**
 * Obtiene las condiciones de un menú con caché
 * @param {string} menuId - ID del menú
 * @returns {Promise<Array>} Lista de condiciones
 */
export async function obtenerCondicionesMenuConCache(menuId) {
  if (condicionesCache.has(menuId)) {
    return condicionesCache.get(menuId);
  }

  const condiciones = await validarCondicionesMenu(menuId);
  condicionesCache.set(menuId, condiciones);
  return condiciones;
}

/**
 * Limpia el caché de condiciones (útil al cerrar sesión)
 */
export function limpiarCacheCondiciones() {
  condicionesCache.clear();
}

/**
 * Verifica si un menú tiene una condición específica
 * @param {string} menuId - ID del menú
 * @param {string} condicion - Condición a verificar (ej: 'NO_VALOR', 'NO_ELIMINAR')
 * @returns {Promise<boolean>} true si tiene la condición
 */
export async function tieneCondicion(menuId, condicion) {
  const condiciones = await obtenerCondicionesMenuConCache(menuId);
  return condiciones.includes(condicion);
}
